export const SERVICES_DELETED_LOADING_TABLE = 'SERVICES_DELETED_LOADING_TABLE'
export const SERVICES_DELETED_LIST_UPDATE = 'SERVICES_DELETED_LIST_UPDATE'
export const SERVICES_DELETED_LIST_UPDATE_ERROR = 'SERVICES_DELETED_LIST_UPDATE_ERROR'
export const SERVICES_DELETED_LIST_UPDATE_SUCCESS = 'SERVICES_DELETED_LIST_UPDATE_SUCCESS'
export const SERVICES_DELETED_LIST_SUCCESS = 'SERVICES_DELETED_LIST_SUCCESS'
export const SERVICES_DELETED_CHECKED_ADD = 'SERVICES_DELETED_CHECKED_ADD'
export const SERVICES_DELETED_CHECKED_ADD_SHIFT = 'SERVICES_DELETED_CHECKED_ADD_SHIFT'
export const SERVICES_DELETED_CHECKED_DELETE = 'SERVICES_DELETED_CHECKED_DELETE'
export const SERVICES_DELETED_CHECKED_DELETE_SHIFT = 'SERVICES_DELETED_CHECKED_DELETE_SHIFT'
export const SERVICES_DELETED_CHECKED_ADD_ID = 'SERVICES_DELETED_CHECKED_ADD_ID'
export const SERVICES_DELETED_CHECKED_MASS_ADD = 'SERVICES_DELETED_CHECKED_MASS_ADD'
export const SERVICES_DELETED_CHECKED_MASS_DELETE = 'SERVICES_DELETED_CHECKED_MASS_DELETE'
export const SERVICES_DELETED_CHANGE_FILTER_TYPE = 'SERVICES_DELETED_CHANGE_FILTER_TYPE'
export const SERVICES_DELETED_CHANGE_FILTER_PROVIDERS = 'SERVICES_DELETED_CHANGE_FILTER_PROVIDERS'
export const SERVICES_DELETED_CHANGE_FILTER_MODE = 'SERVICES_DELETED_CHANGE_FILTER_MODE'
export const SERVICES_DELETED_CHANGE_FILTER_QUERY = 'SERVICES_DELETED_CHANGE_FILTER_QUERY'
export const SERVICES_DELETED_CHANGE_FILTER_SEARCH_TYPE = 'SERVICES_DELETED_CHANGE_FILTER_SEARCH_TYPE'
export const SERVICES_DELETED_MODAL_CLOSE = 'SERVICES_DELETED_MODAL_CLOSE'
export const SERVICES_DELETED_MODAL_OPEN = 'SERVICES_DELETED_MODAL_OPEN'
export const SERVICES_DELETED_CHANGE_PAGE = 'SERVICES_DELETED_CHANGE_PAGE'
export const SERVICES_DELETED_RESTORE_ALL = 'SERVICES_DELETED_RESTORE_ALL'
export const SERVICES_DELETED_RESTORE = 'SERVICES_DELETED_RESTORE'
export const SERVICES_DELETED_RESTORE_SUCCESS = 'SERVICES_DELETED_RESTORE_SUCCESS'
export const SERVICES_DELETED_RESTORE_ERROR = 'SERVICES_DELETED_RESTORE_ERROR'
export const SERVICES_DELETED_CHANGE_FILTER = 'SERVICES_DELETED_CHANGE_FILTER'
export const SERVICES_DELETED_CHANGE_SORT = 'SERVICES_DELETED_CHANGE_SORT'
